import type { RefObject } from 'react'
import type { Answer } from './stamp-rallies/GameCollectionShelfPhoto'
import type { ShelfRowData } from './stamp-rallies/GameCollectionShelfRow'
import type { StampRallyItem } from './stamp-rallies/StampRallyLabels'
import { Modal } from '../components/Modal'
import { assetSrc } from '../media/media-asset.util'
import { gameCollectionBgMap, getTemplate } from '../media/template-loader'
import { GameCollectionHeader } from './stamp-rallies/GameCollectionHeader'
import { GameCollectionImageModal } from './stamp-rallies/GameCollectionImageModal'
import { GameCollectionRecordBlockList } from './stamp-rallies/GameCollectionRecordBlockList'
import { GameCollectionShelf } from './stamp-rallies/GameCollectionShelf'
import { StampRallyLabels } from './stamp-rallies/StampRallyLabels'

type Props = {
  containerRef: RefObject<HTMLDivElement | null>
  activeStampRallyId?: string
  stampRallies: StampRallyItem[]
  setActiveStampRallyId: (stampRallyId: string) => void
  headingContent?: string
  headingTextColor?: string
  headingBgImageTemplate?: string
  headingBgImageUrl?: string
  totalCount: number
  typeCount: number
  maxCount: number
  recordBlockBgColor?: string
  recordBlockTextColor?: string
  shelfRowImageTemplate?: string
  shelfRowImageUrl?: string
  bgImageTemplate?: string
  bgImageUrl?: string
  badgeBgColor?: string
  badgeTextColor?: string
  columnCount?: number
  shelfData: ShelfRowData[]
  handleAnswerClick: (answerId: string) => void
  isImageModalOpen: boolean
  setIsImageModalOpen: (isOpen: boolean) => void
  modalAnswer: Answer | null
  handleShelfPhotoClick: (answer: Answer) => void
}

export function MyPageStampRally(props: Props) {
  const {
    containerRef,
    activeStampRallyId,
    stampRallies,
    setActiveStampRallyId,
    headingContent,
    headingTextColor,
    headingBgImageTemplate,
    headingBgImageUrl,
    totalCount,
    typeCount,
    maxCount,
    recordBlockBgColor,
    recordBlockTextColor,
    shelfRowImageTemplate,
    shelfRowImageUrl,
    bgImageTemplate = 'gameCollectionBgDefault01',
    bgImageUrl,
    badgeBgColor,
    badgeTextColor,
    columnCount,
    shelfData,
    handleAnswerClick,
    isImageModalOpen,
    setIsImageModalOpen,
    modalAnswer,
    handleShelfPhotoClick,
  } = props

  const template = getTemplate(gameCollectionBgMap, bgImageTemplate)
  const bgImage = bgImageUrl ?? assetSrc(template)

  return (
    <div className="grid size-full grid-cols-[100%] grid-rows-[auto_auto_auto_auto_1fr] overflow-hidden bg-cover" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="mx-4 mt-3">
        <StampRallyLabels
          activeStampRallyId={activeStampRallyId}
          stampRallies={stampRallies}
          onClick={setActiveStampRallyId}
        />
      </div>
      <div className="mt-8">
        <GameCollectionHeader
          headingContent={headingContent}
          headingTextColor={headingTextColor}
          headingBgImageTemplate={headingBgImageTemplate}
          headingBgImageUrl={headingBgImageUrl}
        />
      </div>
      <div className="z-10 -mt-8 mb-5">
        <GameCollectionRecordBlockList
          totalCount={totalCount}
          typeCount={typeCount}
          maxCount={maxCount}
          recordBlockBgColor={recordBlockBgColor}
          recordBlockTextColor={recordBlockTextColor}
        />
      </div>
      <div className="mt-4 overflow-hidden">
        <GameCollectionShelf
          shelfRowImageTemplate={shelfRowImageTemplate}
          shelfRowImageUrl={shelfRowImageUrl}
          badgeBgColor={badgeBgColor}
          badgeTextColor={badgeTextColor}
          columnCount={columnCount}
          shelfData={shelfData}
          handleShelfPhotoClick={handleShelfPhotoClick}
        />
      </div>

      <Modal.Root open={isImageModalOpen} onOpenChange={setIsImageModalOpen}>
        <Modal.Portal container={containerRef.current}>
          <Modal.Overlay />
          <Modal.Title />
          <Modal.Description />
          <Modal.Content className="w-[327px] bg-white">
            <GameCollectionImageModal
              answer={modalAnswer}
              onClick={handleAnswerClick}
            />
          </Modal.Content>
        </Modal.Portal>
      </Modal.Root>
    </div>
  )
}
